<template>
  <v-select
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    :rules="rules"
    :loading="loading"
  ></v-select>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
export default {
  name: 'select-LuBillableCategory',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'Lu Billable Category',
    },
    value: Number,
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: Array,
  },
  data() {
    return {
      //templateFIX: if there is more than one pick one to display
      itemText: 'Description',
      // itemText: 'Prefix',
    }
  },
  computed: {
    ...get('luBillableCategory', ['luBillableCategory', 'loading']),
    availableItems() {
      //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
      var list = this.luBillableCategory.filter((i) => true)
      list = list.filter((i) => i.IsActive)
      // if existing record make sure the previous selection is available even if no longer active
      if (this.value > 0) {
        var selectedItem = this.luBillableCategory.find(
          (i) => i.ID == this.value
        )
        if (selectedItem && !list.find((i) => i.ID == this.value) && selectedItem) {
          list.push(selectedItem)
        }
      }
      // sort by column
      list.sort((a, b) => {
        //set the property to sort on
        let textField = this.itemText
        let sort = a[textField] > b[textField] ? 1 : -1
        return sort
      })
      return list
    },
    selected: {
      get() {
        if (this.value) {
          return this.value
        } else {
          return null
        }
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
  },
  created() {
    this.loadLuBillableCategory()
  },
  methods: {
    loadLuBillableCategory: call('luBillableCategory/loadLuBillableCategory'),
  },
}
</script>
<style>
</style>